window.addEventListener('DOMContentLoaded', () => {
	const second = 1000, 
		minute = second * 60, 
		hour = minute * 60, 
		day = hour * 24; 
	
	// const date = new Date().getTime();
	const date = document.querySelector('.timer-top').getAttribute('data-time');
	
	const countDown = new Date(date).getTime(),
		x = setInterval(function() { 
			const now = new Date().getTime(),
				distance = countDown - now;

			document.querySelectorAll('.js-timer-days-top').forEach((unit) => { unit.innerText = Math.floor(distance / (day)) });
			document.querySelectorAll('.js-timer-hours-top').forEach((unit) => { unit.innerText = Math.floor((distance % (day)) / (hour)) });
			document.querySelectorAll('.js-timer-minutes-top').forEach((unit) => { unit.innerText = Math.floor((distance % (hour)) / (minute)) });
			document.querySelectorAll('.js-timer-seconds-top').forEach((unit) => { unit.innerText = Math.floor((distance % (minute)) / second) });
		}, second); 
});
